
/**
 * Javascript lié aux pages agence, notamment pour les formulaires de contact
 */

import './form';
import './flexible-content/bloc-actu-stage'; // BlocActu stage

(function(w) {
    // Définit l'objet Completude
    w.Completude = Object.assign({},w.Completude, { agencecontact : {

            InitAgenceContact() {

                // Active la validation sur le formulaire "J'envoie un message"
                this.formContact = Completude.SetFormValidation($('#send-message'));

                // Au submit du formulaire de contact, on le traite
                $('#send-message button[type="submit"]').on('click', function(e){
                    e.preventDefault();
                    Completude.agencecontact.submitContactForm($('#send-message'));
                });

                // Active la validation sur le formulaire "Je me fais rappeler
                this.formCallback = Completude.SetFormValidation($('#callback-request'));

                // Au submit du formulaire de contact, on le traite
                $('#callback-request button[type="submit"]').on('click', function(e){
                    e.preventDefault();
                    Completude.agencecontact.submitCallbackForm($('#callback-request'));
                });

                // Gestion des compteurs de caractères pour le textarea de chaque formulaire
                $('#field-message, #field-message-2').on('keyup', function () {
                    var max = $(this).attr('maxlength');
                    var len = $(this).val().length;
                    if (len >= max) {
                        $(this).closest('.form__controls-inner').find('.charNum').html('0 caractère restant');
                    } else {
                        var char = max - len;
                        $(this).closest('.form__controls-inner').find('.charNum').html(char + ' caractères restants');
                    }
                });
            },

            // Fonction de traitement pour le formulaire "J'envoie un message"
            submitContactForm(form){

                var self = this;
                // Si le formulaire est valide
                if (self.formContact.validate('contact')){

                    // Données à envoyer
                    var postData = Object.assign({
                        'action': 'wp_send_message',
                        'params': {
                            'Nom': $('#field-name-2').val(),
                            'Commentaires': $('#field-message-2').val(),
                            'IdAgence': $('#field-agency').val(),
                            'EMail': $('#field-email-2').val(),
                            'AccordEMail': $('#field-info').is(':checked'),
                            'Famille': $('#field-take-classes-2').is(':checked')
                        },
                        'g-recaptcha-response' : $('#send-message #g-recaptcha-response').val()
                    }, Completude.GetGlobalUtmFields());

                    // Requete ajax + loading
                    $(form).loading(
                        $.ajax({
                            url: disko_ajax_object.ajaxurl,
                            type: 'post',
                            data: postData,
                            success: function (response) {
                                if (response.success) {
                                    form.hide();
                                    $("#contact-message").removeClass('hide');
                                    $('html,body').animate({
                                        scrollTop: $("#contact-message").offset().top - 200
                                    }, 'slow');
                                    w.Completude.TagManager("MonAgence","EnvoyerUnMessageConfirmation");
                                    w.Completude.TagManagerTunnel('EnvoyerUnMessage/Confirmation');

                                    //Au cas ou l'utilisateur remplie le deuxième formulaire, (se faire rappeler ou message)
                                    // il faut réinitialiser la reponse captcha car elle ne peut servir qu'une seule fois
                                    // La clé du site est dans gglcptch.options.sitekey
                                    if (typeof(grecaptcha)!=='undefined' && typeof(gglcptch)!=='undefined') {
                                        grecaptcha.execute(gglcptch.options.sitekey, { action: 'completude_contact_form' }).then(function (token) {
                                            $(".gglcptch [name=g-recaptcha-response]").each(function() {
                                                $(this).val(token);                                
                                            })                        
                                        });
                                    }
                                }
                                return false;
                            }
                        }).promise());                    
                }
                return false;
            },

            // Fonction de traitement pour le formulaire "Se faire rappeler"
            submitCallbackForm(form){

                var self = this;
                // Si le formulaire est valide
                if (self.formCallback.validate('callback')){

                    // Données à envoyer
                    var postData = Object.assign({
                        'action': 'wp_send_callback_request',
                        'params': {
                            'Nom': $('#field-name').val(),
                            'Commentaires': $('#field-message').val(),
                            'IdAgence': $('#field-agency').val(),
                            'Telephone': $('#field-phone').val(),
                            'EMail': $('#field-email').val(),
                            'AccordEMail': $('#field-info-2').is(':checked'),
                            'Famille': $('#field-take-classes').is(':checked')
                        },
                        'g-recaptcha-response' : $('#callback-request #g-recaptcha-response').val()
                    }, Completude.GetGlobalUtmFields());

                    // Requete ajax + loading
                    $(form).loading(
                        $.ajax({
                            url: disko_ajax_object.ajaxurl,
                            type: 'post',
                            data: postData,
                            success: function (response) {
                                if (response.success) {
                                    form.hide();
                                    $("#callback-message").removeClass('hide');
                                    $('html,body').animate({
                                        scrollTop: $("#callback-message").offset().top - 200
                                    }, 'slow');
                                    w.Completude.TagManager("MonAgence","DemandeDeRappelConfirmation");
                                    w.Completude.TagManagerTunnel('DemandeDeRappel/Confirmation');
                                    //Au cas ou l'utilisateur remplie le deuxième formulaire, (se faire rappeler ou message)
                                    // il faut réinitialiser la reponse captcha car elle ne peut servir qu'une seule fois
                                    // La clé du site est dans gglcptch.options.sitekey
                                    if (typeof(grecaptcha)!=='undefined' && typeof(gglcptch)!=='undefined') {
                                        grecaptcha.execute(gglcptch.options.sitekey, { action: 'completude_contact_form' }).then(function (token) {
                                            $(".gglcptch [name=g-recaptcha-response]").each(function() {
                                                $(this).val(token);                                
                                            })                        
                                        });
                                    }
                                }
                                return false;
                            }
                        }).promise());                    
                }
                return false;
            },

        }});
})(window);

jQuery(function() {
    if (jQuery("#send-message").length > 0 || jQuery("#callback-request").length > 0) {
        window.Completude.agencecontact.InitAgenceContact();
    }
});





